export default __webpack_public_path__ + "static/media/pushups.1bd15a61.jpg";